if (!customElements.get('stola-modal-signup')) {
  customElements.define(
    'stola-modal-signup',
    class StolaModalSignup extends HTMLElement {
      constructor() {
        super();
        this.closeTimer = null;
        this.isClosing = false;
        this.handleEscape = this.handleEscape.bind(this);
      }

      connectedCallback() {
        this.scrollStorageKey = `stola-modal-signup-scroll-${window.location.pathname}`;
        this.panel = this.querySelector('[data-modal-panel]');
        this.closeTargets = this.querySelectorAll('[data-close-modal]');
        this.openers = document.querySelectorAll(`[data-modal-target="#${this.id}"]`);
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[data-modal-submit]');
        this.successState = this.querySelector('.section-modal-signup-form__success-state');
        this.autoOpenOnLoad = this.dataset.autoOpen === 'true' || Boolean(this.querySelector('.section-modal-signup-form.is-submitted'));

        const storedScroll = window.sessionStorage.getItem(this.scrollStorageKey);
        if (storedScroll) {
          window.requestAnimationFrame(() => {
            window.scrollTo({ top: Number(storedScroll), behavior: 'auto' });
          });
          window.sessionStorage.removeItem(this.scrollStorageKey);
        }

        if (this.form && this.successState && this.successState.classList.contains('is-visible')) {
          this.form.classList.add('is-submitted');
          this.autoOpenOnLoad = true;
        }

        this.openers.forEach((opener) => {
          opener.addEventListener('click', this.open.bind(this, opener));
        });

        this.closeTargets.forEach((target) => {
          target.addEventListener('click', this.close.bind(this));
        });

        if (this.form) {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }

        document.addEventListener('keydown', this.handleEscape);

        if (this.autoOpenOnLoad) {
          this.open();
          this.startAutoClose();
        }
      }

      disconnectedCallback() {
        this.clearCloseTimer();
        document.removeEventListener('keydown', this.handleEscape);
      }

      handleEscape(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        if (!this.hasAttribute('open')) return;
        this.close();
      }

      async handleSubmit(event) {
        event.preventDefault();
        if (!this.form) return;

        window.sessionStorage.setItem(this.scrollStorageKey, String(window.scrollY));

        if (this.submitButton) {
          this.submitButton.setAttribute('disabled', 'disabled');
        }

        const formData = new FormData(this.form);
        const action = (this.form.getAttribute('action') || '/contact').split('#')[0];

        try {
          const response = await fetch(action, {
            method: 'POST',
            body: formData,
            headers: {
              Accept: 'text/html',
            },
          });

          if (!response.ok) {
            this.form.submit();
            return;
          }

          this.showSuccess();
        } catch (error) {
          this.form.submit();
        } finally {
          if (this.submitButton) {
            this.submitButton.removeAttribute('disabled');
          }
        }
      }

      showSuccess() {
        if (!this.form) return;
        window.sessionStorage.removeItem(this.scrollStorageKey);
        this.form.classList.add('is-submitted');
        this.startAutoClose();
      }

      open(opener) {
        if (this.hasAttribute('open')) return;

        this.openedBy = opener || document.activeElement;
        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');

        requestAnimationFrame(() => {
          this.classList.add('is-visible');
          trapFocus(this, this.panel);
        });
      }

      close() {
        if (!this.hasAttribute('open') || this.isClosing) return;

        this.isClosing = true;
        this.classList.remove('is-visible');
        this.clearCloseTimer();

        window.setTimeout(() => {
          this.removeAttribute('open');
          this.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('overflow-hidden');
          removeTrapFocus(this.openedBy);
          this.isClosing = false;
        }, 300);
      }

      startAutoClose() {
        this.clearCloseTimer();
        this.closeTimer = window.setTimeout(() => {
          this.close();
        }, 5000);
      }

      clearCloseTimer() {
        if (!this.closeTimer) return;
        window.clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    }
  );
}
